/**
 * The EIP-1193 provider of the wallet the player picked (via wagmi).
 * We keep it here instead of overwriting window.ethereum, so several installed wallets
 * never fight over the global. Falls back to window.ethereum only when nothing was picked.
 */
let active: any = null;
const listeners = new Set<() => void>();

export function setActiveEthereum(p: any) {
  if (active === p) return;
  active = p;
  listeners.forEach(f => { try { f(); } catch { /* ignore */ } });
}

export function getEthereum(): any {
  return active ?? (typeof window !== 'undefined' ? (window as any).ethereum : undefined) ?? null;
}

export function onActiveEthereumChange(f: () => void): () => void {
  listeners.add(f);
  return () => { listeners.delete(f); };
}
